module.exports = __webpack_public_path__ + "img/home-pic-6.22551aaa.jpg";